export const environment = {
  app: 'CoviFactura',
  buyers: 'https://clientes.covifactura.com/compradores',
  cashNowMicrofrontUrl: 'https://clientes.covifactura.com/cajaya/#/caja-ya/my-bills',
  covifacturaLandingUrl: 'https://covifactura.com',
  electronicSignatureUrl: 'https://faudigital.covifactura.com/#/firma-de-documentos',
  uploadDocumentsUrl: 'https://clientes.covifactura.com/#/upload-file/',
  whatsAppUrl: 'https://api.whatsapp.com/send?phone=573102222377',
  
  urlApi: 'https://service.covinoc.cloud/covifacturapi/servicios',
  urlApiBacking: 'https://service.covinoc.cloud/backingspostgresql',
  urlApiCY: 'https://service.covinoc.cloud/caja-ya/api/v1',
  urlApiDev: 'https://service.covinoc.cloud',
  urlApiImg: 'https://admindigital.covinoc.cloud',
  urlApiNit: 'https://service.covinoc.cloud',
  urlApiPayzen: 'https://service.covinoc.cloud/PayzenCorporativo/servicios',
  urlApiPostgres: 'https://service.covinoc.cloud',
  urlApiReports: 'https://service.covinoc.cloud/reportcovifactura/api/v1',
  urlApiProd: 'https://service.covinoc.cloud/covifacturapi/servicios',
  urlEndpoint:
    'https://wsconsultarpdfxmlfactura.dispafel.com:443/DFFacturaElectronicaConsultarPdfXmlFactura/consultarArchivos',
  backingsApiKey: 'CLIENT_APP-b4ck1ng5:53@#thvf53%8',
  buyerIntApiKey: 'CLIENT_APP-124mk12pcas1:zzqwe12WERRcas2',
  cashNowApiKey: 'CLIENT_APP-Cay3RAhy:i&h%ZYKU6z',
  commonsApiKey: 'CLIENT_APP-c0mm0n5:42#@hj78rt%3',
  coviresourceApiKey: 'CLIENT_APP-23KPP1P3039MAS312:RtVEu22126043108@FPEMV',
  expressReportApiKey: 'CLIENT_APP-exPr33xx:Fa12sd@htfl',
  newCoviFacturaApiKey: 'CLIENT_APP-doaneion45012:psnwods@3801VaPFRM',
  newLoginApiKey: 'CLIENT_APP-WL2PjEz9:4d3J9FLnYB2%',
  reportsApiKey: 'CLIENT_APP-exPr33xx:Fa12sd@htfl',
  postgres: true,
  production: true,
}; 